import React, { useState } from 'react'
import axios from 'axios'
import { REGEX_EMAIL } from '../../constants'
import Spinner from 'react-bootstrap/Spinner'

const ComingSoonBlock = ({ comingSoonMessage, nameOfEmailList }) => {

    const [email, setEmail] = useState()
    const [subscribe, setSubscribe] = useState(false)
    const [loading, setLoading] = useState(false)
    const [errorEmail, setErrorEmail] = useState()

    const collectMailToSendgrid = (customFieldId) => {
        const data = {
            contacts: [
                {
                    email: email,
                    custom_fields: { // custom fields just send id 
                        [customFieldId]: 1, // id custom field nameListener_notifications
                        'w6_T': '1' // id custom field notification
                    }
                }
            ]
        }
        const options = {
            method: 'PUT',
            // headers: { 'Authorization': `Bearer ${process.env.GATSBY_SENDGRID_TOKEN}`, 'Content-Type': 'application/json' },
            // url: `${process.env.GATSBY_SENDGRID_API}marketing/contacts`,
            url: `${process.env.GATSBY_CALL_API}/marketing/contacts`,
            data: data
        };

        axios(options)
            .then((response) => {
                setLoading(false)
                if (response.status === 200) {
                    setSubscribe(true)
                }
            })
            .catch(function (error) {
                setLoading(false)
                console.log(error);
            })
    }

    const getCustomFieldID = async () => {
        const options = {
            method: 'GET',
            // headers: { 'Authorization': `Bearer ${process.env.GATSBY_SENDGRID_TOKEN}`, 'Content-Type': 'application/json' },
            // url: `${process.env.GATSBY_SENDGRID_API}marketing/field_definitions`,
            url: `${process.env.GATSBY_CALL_API}/marketing/field_definitions`,
        };
        let response = await axios(options);

        if (response.status === 200) {
            const listCustomField = response.data.custom_fields;
            let found = listCustomField.find(customField => customField.name === nameOfEmailList);
            if (found) {
                collectMailToSendgrid(found.id);
            } else {
                setErrorEmail("Something Wrong With Form!")
            }
        } else {
            setLoading(false)
            console.log(response);
        }
    }

    const handleSubmit = (event) => {
        setLoading(true)
        event.preventDefault()
        let emailMess = ''

        if (!email) {
            emailMess = 'Email is required'
        } else if (!REGEX_EMAIL.test(email)) {
            emailMess = 'Not a valid email'
        }

        if (emailMess) {
            setLoading(false);
            setErrorEmail(emailMess);
        } else {
            getCustomFieldID()
        }
    }

    const handleChange = (event) => {
        setErrorEmail()
        setEmail(event.target.value)
    }

    return (
        <div className="create-account-wrapper notify">
            <div className="row">
                <div className="left-wrapper">
                    <div className="headline">
                        <h2>Coming soon…</h2>
                        <p>{comingSoonMessage}</p>
                    </div>
                </div>
                <div className="right-wrapper">
                    <div className="standard-ver">
                        {
                            !subscribe ? (
                                <>
                                    <div className="title"><p>Let us notify you when it's ready</p></div>
                                    <div className="form-send-mail">
                                        <form onSubmit={handleSubmit}>
                                            <input type="email" aria-required="true" name="email-address" placeholder="Enter your email address" onChange={handleChange} />

                                            <button type="submit" className="button hover-blue-color">
                                                {
                                                    loading ? (
                                                        <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                        />
                                                    ) : (
                                                            <span>NOTIFY ME</span>
                                                        )
                                                }
                                            </button>
                                        </form>
                                    </div>
                                </>
                            ) : (
                                    <div className="thank-you"><p>Thank you for your subscribe!</p></div>
                                )
                        }
                        {errorEmail && (<div className="error">{errorEmail}</div>)}
                    </div>
                </div>
            </div>
        </div >
    )
}

export default ComingSoonBlock
